import {
  formatResponse,
  getLoanById,
  getPropertyOriginalValuesByLoanId
} from "../create-loan/create-loan.action";
import {
  updateLoanDetailsInRedux,
  updatePropertyDetailsInRedux
} from "../stores/loanAndPropertyDetails/loanAndPropertyDetails.action";
import {
  formatLoanDetailsResponse,
  formatPropertyResponse
} from "../create-loan/CreateLoan";
import {
  getPropertyDetails,
  setLoanByIdFailed,
  setLoanByIdSuccess
} from "../create-loan/create-loan.reducer";
import { createAndUpdateComments } from "../stores/budgetReview/budgetReview.action";
import { getUsername } from "../assetManagement/AssetManagement.utils";

export interface BudgetLineItem {
  budgetLineItemId: number;
  unit: string;
  item: string;
  description: string;
  financedBudget: string;
  budget: string;
  isMoreActionsVisible: boolean;
  isDescEditMode: boolean;
  budgetDocumentId: number;
  commentThreadId: string;
  comments?: any[]; // This will be added dynamically
}

export const updateFieldName = (data: any[]): any[] =>
  data.map(({ externalDocumentId, ...rest }) => ({
    DocumentId: externalDocumentId,
    ...rest
  }));

// Helper function to get assigned user
export const getAssignedBy = (
  tasks: any[],
  taskName: string,
  userId: string
): string => {
  const assignedBy = tasks?.[0]?.assignedTasks.find((task: any) =>
    [taskName].includes(task.taskName)
  )?.assignedBy;
  return !assignedBy || ["UnAssigned", "None"].includes(assignedBy)
    ? userId
    : assignedBy;
};

// Helper function to build task object
export const buildTaskObject = (
  taskName: string,
  assignedBy: string,
  assigneePartyId: string,
  taskStatus: string,
  taskId: string,
  comment: string
) => ({
  op: "replace",
  taskName,
  assignedBy,
  assigneePartyId,
  taskStatus,
  taskId,
  comment
});

export const getPropDataByLoanID = async (
  loanId: string,
  loanStage: string,
  loanType: string,
  dispatch: any
) => {
  getPropertyOriginalValuesByLoanId(loanId, loanStage)
    .then((resp: any) => {
      updatePropertyDetailsInRedux(resp.data, dispatch);
      const formattedPropertyData = formatPropertyResponse(
        resp.data,
        loanStage,
        loanType
      );
      dispatch(
        getPropertyDetails({
          propertyDetails: formattedPropertyData,
          thirtyYearLoanPropertyDetails: formattedPropertyData
        })
      );
    })
    .catch((e) => {
      console.error(e);
      // dispatch({
      //   type: GET_PROPERTY_FAILED,
      //   error: {
      //     message: e.message
      //   }
      // });
    });
};

export const handleAddCommentProceed = async (
  lineItemsList: any[],
  docsId: string,
  comment: string,
  row: any,
  comments: any[] = []
) => {
  try {
    const chatId = await createAndUpdateComments(
      row.commentThreadId,
      docsId,
      comment,
      row.budgetLineItemId
    );
    const newCommnets = comments ? [...comments] : [];
    newCommnets.push({
      chatId,
      createdAt: new Date(),
      message: comment,
      firstName: getUsername(),
      lastName: ""
    });
    const lineItemsListTemp = lineItemsList.map((item: any) => {
      if (item.budgetLineItemId === row.budgetLineItemId) {
        return { ...item, commentThreadId: chatId, comments: newCommnets };
      }
      return item;
    });
    const newList = [...lineItemsListTemp];
    const newChatData = { [chatId]: newCommnets };
    return Promise.resolve({ newList, newChatData });
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
};

export const getDataByLoanID = async (
  loanId: string,
  loanStage: string,
  dispatch: any
) => {
  try {
    const response = await getLoanById(loanId, loanStage);

    const loanDetails = formatResponse(response.data);
    updateLoanDetailsInRedux(loanDetails, dispatch);

    const formattedLoanData = formatLoanDetailsResponse(
      response.data,
      loanStage,
      null
    );

    dispatch(
      setLoanByIdSuccess({
        loan: formattedLoanData,
        keepTab: true
      })
    );
  } catch (error) {
    console.error(error);
    dispatch(setLoanByIdFailed());
  }
};
